import { NgModule } from '@angular/core';
import { DropDownModule } from './drop-down-module/drop-down.module';
import { UtilitiesModule } from './utilities-module/utilities.module';
import { ListingModuleModule } from './listing-module/listing.module';
import { SharedUtilitiesModule } from './shared-utilities/utilities/shared-utilities.module';
import { AgingPeriodModule } from './shared-utilities/modules/aging-period/aging-period.module';
import { ViewCacheModule } from './shared-utilities/modules/aging-period/view-cache.module';
import { BranchViewCacheModule } from './shared-utilities/modules/branch-settings/view-cache.module';
import { BranchSettingsModule } from './shared-utilities/modules/branch-settings/branch-settings.module';
import { LayoutModule } from './shared-utilities/modules/layout/layout.module';
import { PermissionModule } from './shared-utilities/modules/permission/permission.module';
import { PersonalizationModule } from './shared-utilities/modules/personalization/personalization.module';
import { SearchModule } from './shared-utilities/modules/search/search.module';
import { SettingsModule } from './shared-utilities/modules/settings/settings.module';

@NgModule({
  imports: [
    DropDownModule,
    UtilitiesModule,
    ListingModuleModule,
    SharedUtilitiesModule,
    AgingPeriodModule,
    BranchSettingsModule,
    LayoutModule,
    PermissionModule,
    PersonalizationModule,
    SearchModule,
    SettingsModule,
    ViewCacheModule,
    BranchViewCacheModule
  ],
  exports: [
    DropDownModule,
    UtilitiesModule,
    ListingModuleModule,
    SharedUtilitiesModule,
    AgingPeriodModule,
    BranchSettingsModule,
    LayoutModule,
    PermissionModule,
    PersonalizationModule,
    SearchModule,
    SettingsModule,
    ViewCacheModule,
    BranchViewCacheModule
  ]
})
export class BlgAkaunNgLibModule { }
